import React, { FC } from 'react'

import { IconDocumentDocProps } from './IconDocumentDoc.types'
import * as Styled from './styles/IconDocumentDoc.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentDoc: FC<IconDocumentDocProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentDocProps['size'],
  isResponsive = false,
}: IconDocumentDocProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#9f18da10-d249-49f2-bf8e-f6633cac278a__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M11.467 13.017h7.53V6.015' stroke='#0D0D0D' strokeLinejoin='round' />
          <path
            d='M20.707 5.075a4.265 4.265 0 0 0-2.774 1.027l-5.408 4.648a4.25 4.25 0 0 0-1.485 3.225v24.93c0 2.2 1.8 4 3.48 4h18.44c2.72 0 4-1.8 4-4V5.075H20.707Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M14.88 23.25v5.63h1.25s2.62.37 2.62-2.88c0-3-2.625-2.75-2.625-2.75H14.88Zm9.077 5.815c1.199 0 2.17-1.344 2.17-3.002 0-1.659-.971-3.003-2.17-3.003-1.198 0-2.17 1.344-2.17 3.003 0 1.658.972 3.002 2.17 3.002Zm8.81-.69a1.912 1.912 0 0 1-1.42.69c-1.232 0-2.232-1.345-2.232-3s1-3 2.233-3a2.015 2.015 0 0 1 1.62.935'
            stroke='#E60000'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='9f18da10-d249-49f2-bf8e-f6633cac278a__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentDoc
